import { requestGet } from '@/common/request';

interface ResultData {
  data: resItem[];
}

type resItem = {
  code: string; //一维类型枚举
  message: string; //一维类型中文名称
  marketMessageTypeList: Array<{
    code: string; // 类型code
    message: string; // 类型名称
  }>;
};

/**
 * 消息中心-查询营销场景消息类型
 * 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1121439607
 * 现有一维类型枚举：
 *     code: 1, //营销场景
 *     code: 2, //消息类型
 */
export default function genericGroupQueryBusinessTypeAll(): Promise<RequestResult<ResultData>> {
  return requestGet('/generic/platMktMsgBk/group/queryBussinessTypeAll');
}
